// backend sends default empty object if there are no array items present
export const isTableCellArrayEmpty = (array) => {
  return !array?.length || !array[0].id
}
